export const barChartData = {
  labels: [] as string[],
  datasets: [
    {
      hidden: true,
      label: '',
      backgroundColor: "#F075A2",
      data: [] as number[]
    },
    {
      label: '',
      backgroundColor: "#6aa8e4",
      data: [] as number[]
    }
  ]
};

export const barChartOptions = {
  maintainAspectRatio: false,
  responsive: true,
  scales: {
    xAxes: [{
      gridLines: {
        color: "rgba(255,255,255,0.5)",
        zeroLineColor: "rgba(255,255,255,1)"
      },
      ticks: {
        fontColor: "#fff",
        fontFamily: "Source Sans Pro",
        fontSize: 14,
        fontStyle: "300"
      }
    }],
    yAxes: [{
      gridLines: {
        color: "rgba(255,255,255,0.5)",
        zeroLineColor: "rgba(255,255,255,1)"
      },
      ticks: {
        beginAtZero: true,
        fontColor: "#fff",
        fontFamily: "Source Sans Pro",
        fontSize: 14,
        fontStyle: "300"
      },
      scaleLabel: {
        display: true,
        labelString: '',
        fontColor: "#fff"
      }
    }]
  },
  legend: {
    display: true,
    position: "bottom",
    labels: {
      boxWidth: 14,
      fontFamily: "Source Sans Pro",
      fontSize: 14,
      fontColor: "#fff",
      fontStyle: "300"
    }
  }
};

export const horizontalChartData =  {
  labels: ["1 - 5", "6 - 10", "11+"],
  datasets: [
    {
      label: '',
      backgroundColor: "#F075A2",
      data: [] as number[]
    },
    {
      label: '',
      backgroundColor: "#6aa8e4",
      data: [] as number[]
    }
  ]
};

export const horizontalChartOptions = {
  maintainAspectRatio: false,
  responsive: true,
  scales: {
    xAxes: [{
      barThickness: 5,
      categoryPercentage: 0,
      gridLines: {
        color: "rgba(255,255,255,0.5)",
        zeroLineColor: "rgba(255,255,255,1)"
      },
      icks: {
        beginAtZero: true,
        fontColor: "#fff",
        fontFamily: "Source Sans Pro",
        fontSize: 14,
        fontStyle: "300"
      },
      scaleLabel: {
        display: true,
        labelString: '',
        fontColor: "#fff"
      }
    }],
    yAxes: [{
      gridLines: {
        color: "rgba(255,255,255,0.5)",
        zeroLineColor: "rgba(255,255,255,1)"
      },
      ticks: {
        beginAtZero: true,
        fontColor: "#fff",
        fontFamily: "Source Sans Pro",
        fontSize: 14,
        fontStyle: "300"
      },
      scaleLabel: {
        display: true,
        labelString: '',
        fontColor: "#fff"
      }
    }]
  },
  legend: {
    display: true,
    position: "top",
    labels: {
      boxWidth: 14,
      fontFamily: "Source Sans Pro",
      fontSize: 14,
      fontColor: "#fff",
      fontStyle: "300"
    }
  }
};